// List of all possible conversion steps
export const STEPS = {
  email: 'email',
  institution: 'institution',
  transferInfo: 'transferInfo',
  follow: 'follow',
  redirect: 'redirect', // redirect should never be displayed. Instead, redirects user to main app
  submit: 'submit',
};
